const toFixedDigit = (num: number | string, numOfFloat = 2) => {
  return Number(num).toFixed(numOfFloat);
};

function findGreatest(num1: number, num2: number) {
  return Math.max(num1, num2);
}

function findMin(num1: number, num2: number) {
  return Math.min(num1, num2);
}

function minMaxValue(data: { x: number; y: number }[]) {
  return data.reduce(
    (acc: any, curr: any) => {
      acc.minX = acc.minX === null ? curr.x : Math.min(acc.minX, curr.x);
      acc.maxX = acc.maxX === null ? curr.x : Math.max(acc.maxX, curr.x);
      acc.minY = acc.minY === undefined ? curr.y : Math.min(acc.minY, curr.y);
      acc.maxY = acc.maxY === undefined ? curr.y : Math.max(acc.maxY, curr.y);
      return acc;
    },
    {
      minX: null,
      maxX: null,
      minY: undefined,
      maxY: undefined,
    }
  );
}

export { toFixedDigit, findGreatest, findMin, minMaxValue };
